import { normaliseRoomCode, PUBLIC_ROOM } from '@decathlon/shared';

export function inviteCode(url = new URL(location.href)): string {
  const value = new URLSearchParams(url.hash.slice(1)).get('room') ?? url.searchParams.get('room');
  if (value === PUBLIC_ROOM) return PUBLIC_ROOM;
  return value === null ? '' : (normaliseRoomCode(value) ?? value);
}
export function roomLink(code: string): string {
  const url = new URL(location.href);
  url.searchParams.delete('room');
  url.hash = `room=${code}`;
  return url.href;
}
export function setRoomUrl(code: string | null): void {
  const url = new URL(location.href);
  url.searchParams.delete('room');
  url.hash = code ? `room=${code}` : '';
  history.replaceState(null, '', url);
}
